import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'
import { ShopActiveFilters } from './shop-active-filters'
import { ShopComponent } from './shop'
import { $elParent } from 'src/scripts/utils/utils'

const ACTIVE_FILTERS_SELECTOR = 'shop-active-filters'
const SHOP_COMPONENT_SELECTOR = 'shop-component'

export class FilterRemoveBtn extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.update()
    }
  }

  update(): void {
    this.updateShop()
    this.updateActiveFilters()
  }

  updateShop() {
    const isResetButton = this.hasAttribute('data-filters-reset')
    const shop: ShopComponent = $elParent(SHOP_COMPONENT_SELECTOR, this)
    const url = this.dataset.url

    if (url && shop) {
      const searchParams =
        url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1)
      const preparedSearchParams = isResetButton ? '' : searchParams

      shop.reset()
      shop.updateBySearchParams(preparedSearchParams)
    }
  }

  updateActiveFilters() {
    const activeFilters: ShopActiveFilters = $elParent(
      ACTIVE_FILTERS_SELECTOR,
      this,
    )

    if (activeFilters) {
      const isRemoveButton = this.hasAttribute('data-filter-remove-btn')
      const isResetButton = this.hasAttribute('data-filters-reset')

      if (isResetButton) {
        activeFilters.reset()
      }

      if (isRemoveButton) {
        if (activeFilters.buttons.length === 1) {
          activeFilters.reset()
        } else {
          activeFilters.setDisable()
          this.remove()
        }
      }
    }
  }
}
